module.exports = __webpack_public_path__ + "static/ms-mag-logo-c5ba3cb1cc1adc474227af1acc7a2a37.png";